import Handlebars from 'handlebars';
import EventHub from '~/eventHub';
import Settings from '~/settings.js';
import profile_template from '~/templates/profile.handlebars';
import GeneralView from '~/generalView';
import OTPView from '~/views/otpView';
import toastr from 'toastr';
import QRCode from 'qrcode';
import getUtilsService from '~/services/utilsService';

var ProfileView = GeneralView.View.extend({
	tagName: "div",
	className: 'User',
	events: {
		'click #data-field-username':'editOpenUsername',
		'click #no-accept-changes-username':'editCloseUsername',
		'click #data-field-email':'editOpenEmail',
		'click #no-accept-changes-email':'editCloseEmail',
		'click #save-username ': 'saveUsername',
		'click #save-email ': 'saveEmail',
		'click #change-pass' : 'editOpenPassword',
		'click #no-accept-changes-password' : 'editClosePassword',
		'click #save-password' : 'savePassword',
		'click #wishnews ': 'checkbox',
		'click #wish2fa ': 'display2faQR',
		'click #submit-token': 'enable2fa',
		'click #qr-2fa-closebutton': function(){this.reset2faCheckbox(false)},
	},

	render: function () {
		this.attachEvents();
		return this;
	},

	attachEvents: function() {
		this.listenTo(EventHub, 'user:setUser', user => {
			var permissions = getUtilsService.getprofilepermissions();
			var params = {
				user: user.id.attributes,
				permissions: permissions,
				req2fa: Settings.req2fa
			}
			var handlebarsTemplate = Handlebars.template(profile_template);
			this.$el.html(handlebarsTemplate(params));
			this.translate();
			if (user.id.attributes.wishNewsLetter){
				this.$el.find('#wishnews').prop('checked', true);
			}
			if (user.id.attributes.enabled2fa){
				this.$el.find('#wish2fa').prop('checked', true);
			}
			const mfa = Parse.Config.current().get("MFA");
			if(!mfa){
				this.$el.find('.last-row').hide();
			}
		});
	},

	editOpenUsername: function() {
		this.$el.find('#data-field-username').fadeOut('fast');
		this.$el.find('#editor-field-username').show('fast');
	},

	editCloseUsername: function(){
		this.$el.find('#editor-field-username').hide('fast');
		this.$el.find('#data-field-username').fadeIn('fast');
	},

	editOpenEmail: function() {
		this.$el.find('#data-field-email').fadeOut('fast');
		this.$el.find('#editor-field-email').show('fast');
	},

	editCloseEmail: function(){
		this.$el.find('#editor-field-email').hide('fast');
		this.$el.find('#data-field-email').fadeIn('fast');
	},

	editOpenPassword : function(){
		this.$el.find('#change-pass').fadeOut('fast');
		this.$el.find('#change-password').show('fast');
	},

	editClosePassword : function(){
		this.$el.find('#change-password').hide('fast');
		this.$el.find('#change-pass').fadeIn('fast');
	},

	saveUsername : function(){
		var value = this.$el.find('#inputusername').val();
		var field = 'username';
		this.$el.find('#editor-field-username').hide('fast');
		this.$el.find('#data-field-username').fadeIn('fast');
		this.saveProfile(value, field);
	},

	saveEmail : function(){
		var value = this.$el.find('#input-email').val();
		var field = 'email';
		this.$el.find('#editor-field-email').hide('fast');
		this.$el.find('#data-field-email').fadeIn('fast');
		this.saveProfile(value, field);
	},

	savePassword : function(){
		var value = this.$el.find('#input-password').val();
		var field = 'password';
		this.$el.find('#change-password').hide('fast');
		this.$el.find('#change-pass').fadeIn('fast');
		this.saveProfile(value, field);
	},

	checkbox: function(){
		var value = false;
		if (this.$el.find('#wishnews').is(':checked')){
			value = true;
		}
		var field = 'wishNewsLetter';
		this.saveProfile(value, field, false);
	},

	display2faQR: function(){
		var value = false;
		if (this.$el.find('#wish2fa').is(':checked')){
			value = true;
		}
		if(value){
			var params = {"userID": Parse.User.current().id };
			var that = this;
			Parse.Cloud.run("Register2FA", params).then((qr) => {
				QRCode.toDataURL(qr.secret).then(url => {
					that.$el.find('#qr-2fa').attr('src', url);
					that.$el.find('#qr-2fa-modal').modal('show');
			  }).catch(err => {
					toastr.error('Error al obtener QR.');
					that.reset2faCheckbox(false);
			  })
			}).catch((e) => {
				toastr.error('Autenticación ya habilitada');
				that.reset2faCheckbox(false);
			});
		} else {
			this.showOTP();
		}
	},

	enable2fa: function(){
		var value = this.$el.find('#token-profile').val();
		var params = {"userID": Parse.User.current().id, "token": value };
		var that = this;
		Parse.Cloud.run("Verify2FA", params).then((result) => {
			if(result.verified){
				toastr.success(arrlang[lang]["ActivateTokenSuccess"]);
				var field = 'enabled2fa';
				that.saveProfile(true, field, false);
				that.$el.find('#token-profile').val("");
			} else {
				toastr.error('Token inválido');
				that.reset2faCheckbox(false);
				that.$el.find('#token-profile').val("");
			}
			that.$el.find('#qr-2fa-modal').modal('hide');
		});
	},

	disable2fa: function(){
		var that = this;
		var field = 'enabled2fa';
		var params = { userID: Parse.User.current().id }
		Parse.Cloud.run("Unregister2FA", params).then(() => {
			that.saveProfile(false, field, false);
			toastr.info("2FA Deshabilitado");
		}).catch((e) => {
			console.log(e);
			toastr.info("2FA Error disabling");
			that.reset2faCheckbox(true);
		});
	},

	saveProfile: function(value, field, trigger_event){
		if (trigger_event == undefined){
			trigger_event = true;
		}
		if (field == 'password') {
			let passw = new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\w~@#$%^&*+=`|{}:;!.?\"()\[\]-]{8,24}$/);
			if(value.match(passw)) {
				Parse.User.current().set(field, value);
				Parse.User.current().save(null,{
					success: function (user) {
						toastr.success("Usuario editado");
					},
					error: function (user, error) {
						console.log(error);
						switch(error.code){
							case 202:
								toastr.error('Usuario ya existe','Error al crear usuario.');
							break;
							case 100:
								toastr.error(arrlang[lang]['InternetConnectionError'],'Error al crear usuario.');
							break;
							default:
								toastr.error('Error al crear usuario.');
							break;
						}
					}
				});
				if (trigger_event){
					EventHub.trigger('user:setUser', {id: Parse.User.current()});
				}
			}
			else {
				toastr.warning('La contraseña debe ser igual o mayor a 8 caracteres, igual o menor a 24 caracteres y tener al menos una minúscula, una mayúscula y un número.','Error al editar usuario.');
			}
		}
		else {
			Parse.User.current().set(field, value);
			Parse.User.current().save(null,{
				success: function (user) {
					toastr.success("Usuario editado");
					if(field == 'email'){
						$('#user_id').html(user.attributes.email);
					}
				},
				error: function (user, error) {
					console.log(error);
					switch(error.code){
						case 202:
							toastr.error('Usuario ya existe','Error al crear usuario.');
						break;
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error al crear usuario.');
						break;
						default:
							toastr.error('Error al crear usuario.');
						break;
					}
				}
			});
			if (trigger_event){
				EventHub.trigger('user:setUser', {id: Parse.User.current()});
			}
		}
	},

	showOTP: function (e){
		var that = this;
		var callback = (value) => {
			var params = {"userID": Parse.User.current().id, "token": value };
			Parse.Cloud.run("Validate2FA", params).then((res) => {
				if(res.verified){
					that.disable2fa();
				} else {
					toastr.warning("Token incorrecto.");
					that.reset2faCheckbox(true);
				}
			}).catch(() => {
				toastr.warning("Token Error");
				that.reset2faCheckbox(true);
			});
		}

		var otpview = new OTPView({callback: callback});
		this.$el.find('#otpview').empty();
		this.$el.find('#otpview').append(otpview.el);
		otpview.render();
	},

	reset2faCheckbox: function(value) {
		this.$el.find('#wish2fa').prop('checked', value);
	},
});
export default ProfileView;
